<template>
  <div>
    <div class="d-flex align-content-between align-items-start">
      <v-select 
        class="flex-grow-1"
        :value="value" 
        :loading="loading"
        :options="doctors" 
        :close-on-select="true"
        :reduce="val => val.id" 
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" 
        placeholder="Medical Professional"
        label="name" 
        clearable 
        @search="fetchDoctors"
        @input="onOptionSelected"
      >
        <template #list-header>
          <li class="d-flex align-content-between align-items-center" style="opacity: 0.8; text-align: center; padding: 5px;">
            <div class="flex-grow-1">Start typing to fetch medical professionals</div>
          </li>
        </template>

        <template #no-options>
          No options available
        </template>
      </v-select>
    </div>
  </div>
</template>
  
<script>
import { get } from 'lodash';
import { BButton } from 'bootstrap-vue'

import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
  
export default {
  components: {
    vSelect,
    BButton,

  },
  props: {
    profession: {
      type: String,
      default: '',
      required: false,
    },
    value: {
      default: "",
      type: String,
      required: false,
    }
  },
  data() {
    return {
      loading: false,
      toggleModal: false,

      doctors: [],
      storeName: "doctorFrequencyStore",
    }
  },
  created() {
    if (this.value){
      this.fetchDoctors(this.value, () => {});
    } else {
      this.doctors = this.getFrequencyStore(this.storeName)
    }
  },
  methods: {
    async fetchDoctors(text, loadingMutator) {
      try {
        this.loading = true; 
        loadingMutator(true);

        const query = {
          page: 1,
          limit: 50,
          search: text || this.value,
          profession: this.profession,
          status: 'active'
        }
        
        const request = await this.useJwt().mainService.users.list(query);
        const { data } = request.data;
        this.doctors = data.map(opt => ({ id: opt._id, name: `${opt.full_name} | ${opt.email}` }))
      } catch (error) {
        const error_message = get(error, "response.data.message") || error.message
        console.log("error_message", error_message)
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message
          },
        });
      } finally {
        this.loading = false;
        loadingMutator(false);
      }
    },
    onOptionSelected(doctor_id){
      this.$emit('change', doctor_id)

      const selectedOption = this.doctors.find(record => record.id === doctor_id);
      if (selectedOption) {
        this.updateFrequencyStore(this.storeName, selectedOption);
      }
    },
  }
}
</script>
